import { Permission } from 'screens/Auth/auth.types'
import { PropsWithChildren } from 'react'
import useUserPermissionsSet from 'screens/Auth/hooks/useUserPermissionsSet'
import { useRecoilValue } from 'recoil'
import authAtom from 'screens/Auth/auth.atom'
import { UserRole } from 'screens/Admin/RolesAndUsers/users.types'

interface IProps {
  permissions: (Permission | 'admin' | UserRole)[]
}

const ProtectedContent = (props: PropsWithChildren<IProps>) => {
  const user = useRecoilValue(authAtom).user
  const userPermissions = useUserPermissionsSet()

  if (user.isAdmin || user.userRole === 'ADMIN') {
    return <>{props.children}</>
  }

  if (
    !props.permissions.some((p) => userPermissions.has(p as any) || p === user.userRole) &&
    props.permissions.length
  ) {
    return null
  }

  return <>{props.children}</>
}

export default ProtectedContent
